import { defineSlotRecipe } from '@chakra-ui/react';
import { segmentGroupAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: segmentGroupAnatomy.keys(),
  variants: {
    variant: {
      toggle: {},
    },
  },
});
